export default __webpack_public_path__ + "static/media/1850_1854.c3749b56.jpg";